import { Component, Directive, EventEmitter, Input, Output } from '@angular/core';
import { BadgePersonInterface } from '../person-badge/person-badge.component';

import '@diekeure/dcr-components/dcr-avatar.js';
import '@diekeure/dcr-components/dcr-card.js';
import '@diekeure/dcr-components/dcr-checkbox.js';
import '@diekeure/dcr-components/dcr-icon.js';
import '@diekeure/dcr-components/dcr-inline-button.js';

@Directive({
  standalone: false,
  selector: '[campusStudentCardActions], [studentCardActions], campus-student-card-actions',
})
export class StudentCardActionsDirective {}

export interface StudentCardActionInterface {
  svgIcon: string;
  routerLink?: string;
}

@Component({
  standalone: false,
  selector: 'campus-student-card',
  templateUrl: './student-card.component.html',
})
export class StudentCardComponent {
  @Input() student: BadgePersonInterface;
  @Input() groupNames: string[];
  @Input() showPreviousClassGroupName = false;
  @Input() previousClassGroupName: string;
  @Input() coins: number;
  @Input() leerId: string;
  @Input() personalCode: string;
  @Input() classNumber: number;
  @Input() action: StudentCardActionInterface;
  @Input() lastLogin: Date;
  @Input() isSmartschool = false;
  @Input() showBadge = false;
  @Input() selectable = false;
  @Input() selected = false;

  @Output() iconClicked = new EventEmitter<boolean>();
  @Output() selectedStudentChange = new EventEmitter<BadgePersonInterface>();

  constructor() {}

  public actionClicked() {
    this.iconClicked.emit(true);
  }

  public toggleSelectStudent() {
    this.selectedStudentChange.emit(this.student);
  }
}
